import initInsights from 'ee/insights';

initInsights();
